import React from 'react';
import { 
  FileText, 
  User, 
  Newspaper, 
  Building2, 
  FileCheck, 
  Droplets,
  Linkedin,
  Download
} from 'lucide-react';

const documents = [
  {
    id: 1,
    title: "Executive CV",
    description: "Premium 2-page corporate executive curriculum vitae",
    icon: FileText,
    file: "/documents/Executive-CV-Ruben-Wargner.pdf",
    type: "PDF"
  },
  {
    id: 2,
    title: "One-Page Profile",
    description: "Investor-ready condensed founder profile",
    icon: User,
    file: "/documents/One-Page-Profile-Ruben-Wargner.pdf",
    type: "PDF"
  },
  {
    id: 3,
    title: "Press Kit",
    description: "Official media kit for journalists & events",
    icon: Newspaper,
    file: "/documents/Press-Kit-Ruben-Wargner.pdf",
    type: "PDF"
  },
  {
    id: 4,
    title: "Government CV",
    description: "RFP-compliant federal & municipal format",
    icon: Building2,
    file: "/documents/Government-CV-Ruben-Wargner.pdf",
    type: "PDF"
  },
  {
    id: 5,
    title: "Tender Cover Page",
    description: "Conference & RFP proposal cover template",
    icon: FileCheck,
    file: "/documents/Tender-Cover-Ruben-Wargner.pdf",
    type: "PDF"
  },
  {
    id: 6,
    title: "Watermark Asset",
    description: "Redspire brand watermark for documents",
    icon: Droplets,
    file: "/documents/Redspire-Watermark.png",
    type: "PNG"
  },
  {
    id: 7,
    title: "LinkedIn Banner",
    description: "Professional social media banner pack",
    icon: Linkedin,
    file: "/documents/LinkedIn-Banner-Ruben-Wargner.png",
    type: "PNG"
  }
];

const DocumentCard = ({ doc }) => {
  const Icon = doc.icon;
  
  return (
    <a 
      href={doc.file}
      download
      className="document-card"
    >
      <div className="document-icon">
        <Icon size={24} />
      </div>
      <div className="document-info">
        <h4 className="document-title">{doc.title}</h4>
        <p className="document-description">{doc.description}</p>
        <span className="document-type">{doc.type}</span>
      </div>
      <div className="document-download">
        <Download size={18} />
      </div>
    </a>
  );
};

const ProfessionalDocuments = () => {
  return (
    <section id="documents" className="documents-section">
      <div className="container">
        <div className="section-header">
          <span className="section-label">Resources</span>
          <h2 className="heading-2">Professional Documents</h2>
          <p className="section-subtitle">
            Download executive materials, press resources, and brand assets
          </p>
        </div>
        
        <div className="documents-grid">
          {documents.map((doc) => (
            <DocumentCard key={doc.id} doc={doc} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProfessionalDocuments;
